import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import { useNavigate  } from 'react-router-dom';
import { Button } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';


export default function NavigationBreadCrumbs(steps) {
    const navigate = useNavigate();
    const handleClick =(route)=>{
        navigate(route)
      }
    const def = [{ 'title': 'Home', 'name':'home', 'path': '/verify', 'current': true }]
    const bread = (params) => {
        let res = []
        const b = arrayFormat(def, params)
        b.map((value, indx) => {
            if (value.current) {
                res.push(<Typography key={indx} color="text.primary">  {value.title} </Typography>)
            } else {
                res.push(<Link underline="hover" key={indx} color="inherit" href="/" onClick={(e) => { e.preventDefault(); handleClick(value.path) }}>  {value.title} </Link>)
            }
        })
        return res
    }

    const arrayFormat = (def, params) => {
        if (params.steps[0].name === 'verify') {
            def[0].title = ""
            return def
        }
        def[0].current = false
        return [...def, ...params.steps]
    }
    
  return (
    <Stack spacing={2}>
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        <Button onClick={(e) => { e.preventDefault(); navigate(-1) }}  sx={{ backgroundColor: "#E8B40A", fontWeight: 900, fontSize: 11 }} variant="contained" size="large" startIcon={<ChevronLeftIcon />}> Back </Button> {bread(steps)}
      </Breadcrumbs>
    </Stack>
  );
}